require('./bootstrap');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


$(document).ready(function(){

    $.fancybox.defaults.animationEffect = "fade";
    $.fancybox.defaults.wheel = "zoom";

    function configNavMenuDropdown( ) {

        $('.main-nav .nav-link.dropdown-toggle').on('click', function(e) {

            if (window.matchMedia("(min-width: 992px)").matches) {
                // Only do this on desktop environment.
                let dropdown_item = $(this).siblings('.dropdown-menu').find('.dropdown-item').first();

                if ( dropdown_item ) {
                    let target_url = dropdown_item.attr('href');
                    window.location = target_url;
                }
            }

        });
    }

    function buildBrandSlick( ) {

        $('.brand-logos').slick({
            infinite: true,
            speed: 5000,
            slidesToShow: 5,
            slidesToScroll: 5,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover:false,
            pauseOnFocus: false,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        speed: 3000,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        speed: 2000,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    function buildGallerySlick() {

        $('.social-goods-gallery').slick({
            infinite: true,
            speed: 3000,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover:false,
            pauseOnFocus: false,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        // arrows: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // arrows: false,
                        dots: false
                    }
                },
            ]
        });
    }

    function buildPremiumWorkspaceSlick() {

        $('.premium-workspace-gallery').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover:false,
            pauseOnFocus: false,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        // arrows: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        // arrows: false,
                        dots: false
                    }
                },
            ]
        });
    }

    function buildEatonSlick( ) {
        $("#eaton-carousel").slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
        });
    }

    // configNavMenuDropdown();

    buildBrandSlick();
    buildGallerySlick();
    buildPremiumWorkspaceSlick();
    buildEatonSlick( );

    /* Investor Relations */

    $(".group_title").click(function(e) {

        let parent_group = $(this).parents('.ir_entry_group');

        let document_wrapper = parent_group.find('.group_documents');

        if ( parent_group.hasClass('ir_entry_group_active') ) {
            parent_group.removeClass('ir_entry_group_active');
            document_wrapper.collapse('hide');
        } else {
            parent_group.addClass('ir_entry_group_active');
            document_wrapper.collapse('show');
        }

    });

});

/**
 * Cookies
 */

(function(){

    var cookieName = 'displayCookieConsent';

    function showCookieBar() {

        if (_shouldDisplayConsent() ){

            jQuery('#cookieChoiceInfo').css('display', 'block');
        } else {
            console.log("no need to add cookie bar.");
        }

        // Update
        var pdf_link = jQuery('a.footer_disclaimer').attr('href');

        jQuery('a.cookie_privacy_pdf').attr('href', pdf_link);

        jQuery('#cookieChoiceDismiss').click(function ( event) {

            event.preventDefault();

            _saveUserPreference();

            _hideCookieBar();

        });


    }

    function _saveUserPreference() {
        var expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        document.cookie = cookieName + '=y;path=/; expires=' + expiryDate.toGMTString();
    }

    function _hideCookieBar( ) {
        jQuery('#cookieChoiceInfo').addClass('cookieChoiceInfo--hide');
    }

    function _shouldDisplayConsent() {
        // Display the header only if the cookie has not been set.
        return !document.cookie.match(new RegExp(cookieName + '=([^;]+)'));
    }

    if (document.addEventListener) {
        document.addEventListener('DOMContentLoaded', showCookieBar);
    } else {
        document.attachEvent('onreadystatechange', function(event) {
            if (document.readyState === "complete") {
                showCookieBar();
            }
        });
    }


})();

require('./social_good');

require('./anniversary');

require('./our_people');
